// Reject incomplete/error payloads before reporting a successful download.
export async function validateDownload(blob, format, language = 'en') {
  const fail = () => {
    throw new Error(language === 'tr'
      ? 'Dosya eksik veya geçersiz. İndirme kaydedilmedi; tekrar deneyin.'
      : 'The file is incomplete or invalid. It was not saved; please retry.');
  };
  if (!blob || blob.size < 20) fail();
  const kind = format.toLowerCase();
  const head = new Uint8Array(await blob.slice(0, 84).arrayBuffer());
  const signature = new TextDecoder().decode(head);
  if (/^\s*(?:<!doctype|<html|\{"(?:detail|error)")/i.test(signature)) fail();
  if (kind === 'glb') {
    if (head.length < 20 || signature.slice(0, 4) !== 'glTF') fail();
    const header = new DataView(head.buffer);
    if (header.getUint32(4, true) !== 2 || header.getUint32(8, true) !== blob.size) fail();
  } else if (kind === 'pdf') {
    if (!signature.startsWith('%PDF-') || !(await blob.slice(-1024).text()).includes('%%EOF')) fail();
  } else if (['step', 'stp'].includes(kind)) {
    if (!signature.startsWith('ISO-10303-21;') || !(await blob.slice(-256).text()).includes('END-ISO-10303-21;')) fail();
  } else if (['iges', 'igs'].includes(kind)) {
    const lines = (await blob.slice(-512).text()).trimEnd().split(/\r?\n/);
    if (lines[lines.length - 1]?.[72] !== 'T') fail();
  } else if (kind === 'dxf') {
    if (!signature.includes('SECTION') || !(await blob.slice(-128).text()).trimEnd().endsWith('EOF')) fail();
  } else if (kind === 'stl' && !signature.trimStart().startsWith('solid')) {
    if (head.length < 84 || 84 + new DataView(head.buffer).getUint32(80, true) * 50 !== blob.size) fail();
  }
  return blob;
}
